import { axiosService } from './axios.service'

const _axiosService = axiosService();

let endpoints = {
    me_permissions: `/user/me/permissions`,
    store: `/store`,
    actives: `/order/store/actives`,
    orderStore: `/order/store/`,
    dishId: `/store/dish/`,
    history: `/order/store/history`,
    orderId: `/order/`,
    category: `/store/category`,
    isActive: `/store/product`,
    schedulePut: `/store/schedule`,
    specialWeekend: '/store/weekend',
    storeWeekend: '/store/weekend',
    scheduleDay: '/store/schedule/day',
    permission_post: '/auth/store/user',
}

const getStorageUser = () => {
    const user = JSON.parse(localStorage.getItem('user'));

    localStorage.setItem('authToken', JSON.stringify(user?.data.tokens.accessToken));
    localStorage.setItem('refreshToken', JSON.stringify(user?.data.tokens.refreshToken));

    const storeId = user?.data.user.store._id
    endpoints.storeId = `/store/${storeId}`
    endpoints.dishIdGet = `/store/${storeId}/dish/`
}

const getOrders = async () => {
    try {
        const response = await _axiosService.apiRequest({
            url: endpoints.actives,
            method: "GET",
        })
        if (response.status === 204) {
            return []
        } else {
            return response.data
        }
    } catch(error) {
        console.error('error:', error)
    }
}

const getOrderById = async (orderId) => {
    try {
        const url = endpoints.orderStore + orderId
        const response = await _axiosService.apiRequest({
            url: url,
            method: "GET",
        });
        if (response.status === 204) {
            return []
        } else {
            return response.data
        }
    } catch(error) {
        console.error('error:', error)
    }
}

const getStoreById = async () => {
    try {

        getStorageUser()
        const response = await _axiosService.apiRequest({
            url: endpoints.storeId,
            method: "GET",
        });

        if (response.status === 204 || (response.status == 200 && !response.data)) {
            return [];
        }else{
            localStorage.setItem('store', JSON.stringify(response.data));
            return response.data;
        }
    } catch {
        console.error('error')
    }
};

const patchStore = async (data) => {
    try {
        const response = await _axiosService.apiRequest({
            url: endpoints.store,
            method: "PATCH",
            data: data
        });
        return response
    } catch {
        console.error('error')
    }
};

const getDishById = async (dishId) => {
    try {
        getStorageUser()
        const url = endpoints.dishIdGet + dishId
        const response = await _axiosService.apiRequest({
            url: url,
            method: "GET",
        });

        if (response.status === 204) {
            return [];
        } else {
            return response.data;
        }
    } catch {
        console.error('error')
    }
};

const downloadTemplate = async () => {
    try {
        const response = await _axiosService.apiRequest({
            url: endpoints.store + '/product/report?fileFormat=xlsx',
            method: "GET",
            data: {},
            responseType: 'blob',
        });

        if (response.status === 204) {
            return null;
        }

        return response
    } catch {
        console.error('error')
    }
};

const importDishesFromFile = async (formData) => {
    try {
        const response = await _axiosService.apiRequest({
            url: endpoints.dishId + 'import',
            method: 'POST',
            data: formData,
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response
    } catch (error) {
        console.error('Error al importar platos:', error)
        throw error
    }
};

const postDishById = async (data) => {
    try {
        const response = await _axiosService.apiRequest({
            url: endpoints.dishId + 'many',
            method: "POST",
            data: data
        });
        return response
    } catch {
        console.error('error')
    }
};

const postDishByNewDish = async (data) => {
    try {
        const response = await _axiosService.apiRequest({
            url: endpoints.dishId,
            method: "POST",
            data: data
        });
        return response
    } catch {
        console.error('error')
    }
};

const putDishById = async (dishId, data) => {
    try {
        const url = endpoints.dishId + dishId
        const response = await _axiosService.apiRequest({
            url: url,
            method: "PUT",
            data: data
        });

        return response
    } catch {
        console.error('error')
    }
};

const deleteDishbyId = async (dishId) => {
    try {
        const url = endpoints.dishId + dishId
        const response = await _axiosService.apiRequest({
            url: url,
            method: "DELETE",
        });

        return response
    } catch {
        console.error('error')
    }
};

const getHistory = async (params = {}, page = 1, limit = 10) => {
    const queryString = new URLSearchParams(params).toString();
    const baseURL = endpoints.history;
    const urlWithParams = queryString ? `${baseURL}?${queryString}` : baseURL;

    const finalURL = `${urlWithParams}${queryString ? '&' : '?'}limit=${limit}&page=${page}`;
    try {

        const response = await _axiosService.apiRequest({
            url: finalURL,
            method: "GET",
        });
        if (response.status === 204) {
            return [];
        }
        return response.data;
    } catch (error) {
        console.error('error', error)
        return [];
    }
};


const downloadHistory = async (params = {}) => {
    try {
        const response = await _axiosService.apiRequest({
            url: `${endpoints.history}/report?${new URLSearchParams(params).toString()}`,
            method: "GET",
            data: {},
            responseType: 'blob', 
        });
        
        if (response.status === 204) {
            return null;
        } 

        return response;
        
    } catch (error) {
        console.error('Error downloading file:', error);
        return null;
    }
}


const getSchedule = async () => {
     const user = JSON.parse(localStorage.getItem('user'));
    const storeId = user?.data.user.store._id
    const schedule = `/store/${storeId}`
    try {
        const response = await _axiosService.apiRequest({
            url: schedule,
            method: "GET",
        });
        if (response.status === 204) {
            return [];
        } else {
            return response.data;
        }
    } catch {
        console.error('error')
    }
};

const postSpecialWeekend = async (data) => {
    try {
        const response = await _axiosService.apiRequest({
            url: endpoints.specialWeekend,
            method: "POST",
            data: data
        });
        return response
    } catch {
        console.error('error')
    }
};

const postSpecialWeekendWithId = async (data, id) => {
    try {
        const response = await _axiosService.apiRequest({
            url: `${endpoints.specialWeekend}/${id}`,
            method: "PATCH",
            data: data
        });
        return response
    } catch {
        console.error('error')
    }
};

const putSchedule = async (data) => {
    try {
        const response = await _axiosService.apiRequest({
            url: endpoints.schedulePut,
            method: "PUT",
            data: data
        });
        return response
    } catch {
        console.error('error')
    }
};

const deleteSpecialWeekend = async (categoryId) => {
    try {
        const url = `${endpoints.storeWeekend}/${categoryId}`
        const response = await _axiosService.apiRequest({
            url: url,
            method: "DELETE",
        });

        return response
    } catch {
        console.error('error')
    }
};


const patchOrderId = async (orderId, data) => {
    try {
        const url = endpoints.orderId + orderId
        const response = await _axiosService.apiRequest({
            url: url,
            method: "PATCH",
            data: data
        });
        return response
    } catch {
        console.error('error')
        return 'error'
    }
};

const patchScheduleDay = async ( data) => {
    try {
        const response = await _axiosService.apiRequest({
            url: endpoints.scheduleDay,
            method: "PATCH",
            data: data
        });
        return response
    } catch {
        console.error('error')
        return 'error'
    }
};

const postCategory = async (data) => {
    try {
        const response = await _axiosService.apiRequest({
            url: endpoints.category,
            method: "POST",
            data: data
        });

        return response
    } catch {
        console.error('error')
    }
};

const deleteCategorybyId = async (categoryId) => {
    try {
        const url = `${endpoints.category}/${categoryId}`
        const response = await _axiosService.apiRequest({
            url: url,
            method: "DELETE",
        });

        return response
    } catch {
        console.error('error')
    }
};

const editCategorybyId = async (categoryId, data) => {
    try {
        const url = `${endpoints.category}/${categoryId}`
        const response = await _axiosService.apiRequest({
            url: url,
            method: "PATCH",
            data: data
        });

        return response
    } catch {
        console.error('error')
    }
};

const putCategoriesOrder = async (data) => {
    try {
        const url = endpoints.category
        const response = await _axiosService.apiRequest({
            url: url,
            method: "PUT",
            data: data
        });

        return response
    } catch(error) {
        console.error('error:', error)
    }
}

const patchIsActive = async (dishId, data) => {
    try {
        const url = `${endpoints.isActive}/${dishId}/isactive`
        const response = await _axiosService.apiRequest({
            url: url,
            method: "PATCH",
            data: data
        });
        return response
    } catch {
        console.error('error')
    }
};

const deletePermission = async (permissionId) => {
    try {
        const url = `${endpoints.store}/user/${permissionId}`
        const response = await _axiosService.apiRequest({
            url: url,
            method: "DELETE",
        });

        return response
    } catch {
        console.error('error')
    }
};

const patchPermission = async (permissionId, data) => {
    try {
        const url = `${endpoints.store}/user/${permissionId}`
        const response = await _axiosService.apiRequest({
            url: url,
            method: "PATCH",
            data: data
        });
        return response
    } catch {
        console.error('error')
    }
}; 

const postPermission = async (data) => {
    try {
        const url = `${endpoints.permission_post}`
        const response = await _axiosService.apiRequest({
            url: url,
            method: "POST",
            data: data
        });
        return response
    } catch {
        console.error('error')
    }
};

const getPermissions = async () => {
    try {
        const url = `${endpoints.store}/user`
        const response = await _axiosService.apiRequest({
            url: url,
            method: "GET",
        });
        return response
    } catch {
        console.error('error')
    }
};


const getRoles = async () => {
    try {
        const url = `${endpoints.store}/role`
        const response = await _axiosService.apiRequest({
            url: url,
            method: "GET",
        });
        return response
    } catch {
        console.error('error')
    }
};

const getMePermisions = async () => {
    try {
        getStorageUser()
        const response = await _axiosService.apiRequest({
            url: endpoints.me_permissions,
            method: "GET",
        });
        return response
    } catch {
        console.error('error')
    }
};

export const apiService = {
    getOrders,
    getStoreById,
    patchStore,
    getDishById,
    postDishById,
    putDishById,
    deleteDishbyId,
    getHistory,
    patchOrderId,
    postCategory,
    patchIsActive,
    deleteCategorybyId,
    getOrderById,
    editCategorybyId,
    getSchedule,
    putSchedule,
    postSpecialWeekend,
    deleteSpecialWeekend,
    putCategoriesOrder,
    patchScheduleDay,
    postSpecialWeekendWithId,
    postDishByNewDish,
    patchPermission,
    postPermission,
    getPermissions,
    deletePermission,
    getRoles,
    getMePermisions,
    downloadHistory,
    downloadTemplate,
    importDishesFromFile,
};


